<div class="spinner">
    <span></span>
    <span></span>
    <span></span>
</div>